export enum TypeOfMessage {
  info = "info",
  danger = "danger",
  success = "success",
  warning = "warning",
}
